'use strict';

var FlightClassMixGraphDirective = function FlightClassMixGraphDirective(Chart) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/flight-class-mix-chart.html'),
    controller: 'FlightClassMixChartController',
    scope: {
      mode: '@',
      screen: '@',
      postDepartureMode: '='
    },
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var chart = new Chart(chartElement, scope.chartFormatters);
      scope.renderChartDataPresent = function (data) {
        chart.withMetric(scope.selectedMetric).render(data);
      };
      scope.$on('brush-filter:filterApplied', scope.onBrushFilter);
      scope.$on(scope.screen + ':scenariosChanged', function () {
        scope.updateChart(scope.filterMetric);
      });
    }
  };
};
FlightClassMixGraphDirective.$inject = ['FlightClassMixChart'];
module.exports = FlightClassMixGraphDirective;